import request from '@/utils/request'
/**
 * 获取工作台数据
 */
export const getworkTableData = async () => {
  return await request({
    url: '/sys/v1/home/page/applyStatistics',
    method: 'GET'
  })
}
